import '@mdi/font/css/materialdesignicons.css'
// import 'typeface-roboto/index.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#88c143',
      },
    },
  },
})
